import { useCallback, useContext } from 'react';
import { _useReportCtx } from '../../core/reports/report-ctx';
import { ListViewContext } from '../../core/list-view/context/ListViewContext';

export interface ApplyColumnFilterOptions<TValue> {
  field: string;
  value: TValue | null | undefined;
  formatValue?: (value: TValue | null | undefined) => unknown;
}

/**
 * Applies a table cell value through the nearest report form or list view.
 * On reports, the form field is set and submitted so the toolbar stays in sync.
 */
export function useApplyColumnFilter<TValue>({
  field,
  value,
  formatValue,
}: ApplyColumnFilterOptions<TValue>) {
  const reportContext = _useReportCtx({ innerThrowIfMissingProvider: false });
  const listViewContext = useContext(ListViewContext);

  return useCallback(() => {
    if (value == null || value === '') {
      return;
    }

    const nextValue = formatValue ? formatValue(value) : value;

    if (reportContext) {
      void reportContext.applyFormField(field, nextValue);
      return;
    }

    listViewContext?.setFilterValue(field, nextValue);
  }, [field, formatValue, listViewContext, reportContext, value]);
}
